// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7gkLE","card":"styles_card__18iap","overlay":"styles_overlay__8EM71","content":"styles_content__aTwR+"};